import { useEffect, useState, type ReactElement } from 'react';
import { Bookmark } from 'lucide-react';
import type { ArticleSummary } from '@ai-radar/shared';
import { api } from '../api';
import { ArticleCard } from '../components/ArticleCard';
import { EmptyState, LoadingList } from '../components/States';
import { getFavorites } from '../lib/favorites';

export function FavoritesPage(): ReactElement {
  const [articles, setArticles] = useState<ArticleSummary[]>([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const load = async (): Promise<void> => {
      const ids = getFavorites();
      if (!ids.length) { setLoading(false); return; }
      const result = await Promise.all(ids.map((id) => api.article(id).then((article) => article).catch(() => null)));
      setArticles(result.filter((article): article is NonNullable<typeof article> => Boolean(article)).map((article) => article));
      setLoading(false);
    };
    void load();
    const sync = (): void => void load();
    window.addEventListener('ai-radar:favorites', sync);
    return () => window.removeEventListener('ai-radar:favorites', sync);
  }, []);
  return <div className="pb-12"><div className="mb-8"><p className="eyebrow flex items-center gap-2"><Bookmark size={13} />La tua selezione</p><h1 className="mt-2 font-display text-4xl font-semibold tracking-[-0.065em] text-ink">Preferiti</h1><p className="mt-3 text-sm text-muted">Segnali da rileggere, salvati in questo browser.</p></div>{loading ? <LoadingList /> : articles.length ? <div>{articles.map((article) => <ArticleCard key={article.id} article={article} />)}</div> : <EmptyState />}</div>;
}
